import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import boxIcon from '@/assets/images/visualisations/box.svg';
import barIcon from '@/assets/images/visualisations/bar.svg';
import histogramIcon from '@/assets/images/visualisations/histogram.svg';
import stackedBar from '@/assets/images/visualisations/stackedbar.svg';
import { cohortChart } from '../constants';

export const cohortChartIcon = {
  bar: barIcon,
  stackedbar: stackedBar,
  box: boxIcon,
  histogram: histogramIcon,
};

const CohortChartDropdownItems = ({ value, onChange }) => {
  const intl = useIntl();
  return (
    Object.keys(cohortChart).map((chart) => (
      <Dropdown.Item
        key={`cohort_chart_dropdown_${cohortChart[chart]}`}
        text={intl.formatMessage({ id: `chart.${cohortChart[chart].toLowerCase()}` })}
        value={cohortChart[chart]}
        active={cohortChart[chart] === value}
        image={cohortChartIcon[cohortChart[chart].toLowerCase()]}
        onClick={() => onChange(cohortChart[chart])}
      />
    ))
  );
};

export default CohortChartDropdownItems;
